import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getVenuesTemp = createAsyncThunk('venueSummaryTemp/getVenues',
  async (params: any) => {
    const paramText = new URLSearchParams(params)
    const response: AxiosResponse = await instance.get(`v1/venues?${paramText}`)
    return response.data
  })
